import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import { Paginator } from "@/Helpers/Paginator.js"
import AgentReceiptRepository from "@/repositories/AgentReceiptRepository.js"
export class AgentReceiptService {
  constructor(agentId) {
    this.repository = AgentReceiptRepository
    this.list = []
    this.newReceipt = {
      agentId: null,
      amount: null,
    }
    this.paginator = new Paginator(resources.agents.receipts + "/" + agentId)
  }

  fromJson(data) {
    const detail = (data.detail && data.detail[0]) || {}
    const commissionCredited = Number(detail.commission_credited || 0)
    let receipt = {
      id: data.id,
      amountCollected: Number(data.amount || 0),
      commissionCredited: commissionCredited,
      amountReceived: Number(data.amount || 0) - commissionCredited,
      dueAtVisit: detail.due || 0,
      collectedSinceLastVisit: Number(detail.since_last_visit || 0),
      receiver: data.user.name,
      createdAt: data.created_at
        .toString()
        .replace(/T/, " ")
        .replace(/\..+/, ""),
    }
    return receipt
  }

  updateList(data) {
    this.list = data.map(this.fromJson)
    return this.list
  }

  async addNewReceipt() {
    try {
      const receiptPM = {
        agent_id: this.newReceipt.agentId,
        amount: this.newReceipt.amount,
      }
      let response = await this.repository.create(receiptPM)
      if (response.status === 200 || response.status === 201) {
        this.resetNewReceipt()
        return response
      } else {
        return new ErrorHandler(response.error, "http", response.status)
      }
    } catch (e) {
      let errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }
  resetNewReceipt() {
    this.newReceipt = {
      agentId: null,
      amount: null,
    }
  }
}
